<template>
  <div class="component-input-width autocomplete">
    <div class="data-select">
      <div v-for="(item, index) in dataSelectN" :key="index" class="content-data-select">
        {{ item.name }}
        <img class="icon pointer" src="@/assets/images/icon/close.svg" alt="icon close" @click="removeSelect(index)" />
      </div>
    </div>
    <div ref="dropdownAutoComplete" class="component-input">
      <Field
        ref="veeField"
        v-slot="{ field, meta }"
        v-model="value"
        :name="name"
        :rules="activeRules"
        :validate-on-blur="true"
        :validate-on-change="true"
        :validate-on-input="true"
      >
        <input
          v-bind="field"
          v-model="value"
          :class="[
            classN,
            'input-size form-control',
            'input-select',
            { 'form-control-error': meta.touched && !meta.valid },
          ]"
          :style="styleN"
          :name="'FieldShow' + name"
          autocomplete="off"
          :placeholder="placeholder"
          :disabled="disabled"
          :maxlength="maxlength"
          type="text"
          @keyup="onKeyup($event.target.value)"
          @focusout="handleFocusOut"
          @focusin="handleFocusIn($event.target.value)"
          @keypress="handleKeypress($event)"
          @keydown="handleKeydown($event)"
        />
      </Field>
      <font-awesome-icon
        v-if="modelValue || value"
        icon="circle-xmark"
        class="image-select clear-icon"
        :class="[disabled ? '' : 'pointer']"
        alt="clear"
        @click="disabled ? '' : clearSelect()"
      />
      <font-awesome-icon
        v-else
        icon="angle-down"
        class="image-select"
        :class="[disabled ? '' : 'pointer']"
        alt="icon search"
        @click="disabled ? '' : toggleDropdown()"
      />
      <ErrorMessage v-slot="{ message }" :name="name">
        <p class="message-error">{{ message }}</p>
      </ErrorMessage>
      <div class="dropdown-content" :style="dropdown ? 'display: block; overflow: auto;' : 'display: none;'">
        <!--<div v-show="placeholder">
          <div class="add" @click="select('')">{{placeholder}}</div>
          <div class="line"></div>
        </div>-->
        <div>
          <div v-show="zeroSelect" class="add placeholder" @click="select({ value: '', name: '' })">
            {{ placeholder }}
          </div>
        </div>
        <div v-for="(item, index) in filteredOptions" :key="index">
          <div v-show="index != 0 || zeroSelect" class="line"></div>
          <div class="add" @click="select(item)">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentInput',
  props: [
    'name',
    'placeholder',
    'modelValue',
    'type',
    'classN',
    'styleN',
    'disabled',
    'maxlength',
    'rules',
    'optionSelect',
    'dataSelect',
    'iconN',
    'zeroSelect',
    'specialValue',
    'specialLabel',
  ],
  emits: [
    'update:modelValue',
    'changeSelect',
    'keyup-data',
    'focusout',
    'focusin',
    'keypress',
    'keydown',
    'update:dataSelect',
  ],
  data() {
    return {
      dropdown: false,
      dataSelectN: this.dataSelect,
      isTyping: false,
      typeN: this.type,
      value: this.modelValue,
    }
  },
  computed: {
    filteredOptions() {
      const valStr = String(this.value ?? '')
      if (!valStr || valStr.trim() === '') {
        return this.optionSelect || []
      }
      if ((this.optionSelect || []).some((item) => item.name === valStr)) {
        return this.optionSelect || []
      }
      const search = valStr.toLowerCase()
      return (this.optionSelect || []).filter((item) => (item.name || '').toLowerCase().includes(search))
    },
    activeRules() {
      if (!this.rules) return undefined
      // Single-select mode: use original rules as-is
      if (this.dataSelect === undefined) return this.rules
      // Chip mode: validate based on chip selections, not text input
      if (this.dataSelectN?.length > 0) return undefined
      if (this.specialValue && this.modelValue === this.specialValue) return undefined
      return () => 'กรุณากรอกข้อมูล'
    },
  },
  watch: {
    activeRules() {
      this.$nextTick(() => {
        if (this.$refs.veeField) {
          this.$refs.veeField.validate()
        }
      })
    },
    value() {
      this.$nextTick(() => {
        if (this.$refs.veeField) {
          this.$refs.veeField.validate()
        }
      })
    },
    modelValue() {
      // In chip mode: show special value as text, otherwise clear the text input
      // after selection/external reset. Keep active search text while the dropdown is open.
      if (this.dataSelect !== undefined) {
        if (this.specialValue && this.modelValue === this.specialValue) {
          this.value = this.specialLabel || 'ไม่มีกฎหมายแม่บท'
        } else if (!this.dropdown) {
          this.value = ''
        }
      } else {
        this.syncValueFromModel(this.optionSelect, true)
      }
    },
    dataSelect(newVal) {
      this.dataSelectN = newVal
      this.handleNoBaseLawInChips()
    },
    optionSelect(newVal) {
      if (this.dataSelect !== undefined || this.dropdown) return
      this.syncValueFromModel(newVal, false)
    },
  },
  mounted() {
    document.addEventListener('click', this.focusoutBtn)
    if (this.modelValue) {
      this.$emit('update:modelValue', this.modelValue.toString())
      this.syncValueFromModel(this.optionSelect, false)
    }
    this.handleNoBaseLawInChips()
    if (this.dataSelect !== undefined && this.specialValue && this.modelValue === this.specialValue) {
      this.value = this.specialLabel || 'ไม่มีกฎหมายแม่บท'
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.focusoutBtn)
  },
  methods: {
    syncValueFromModel(options = this.optionSelect, clearWhenMissing = true) {
      if (this.modelValue === undefined || this.modelValue === null || this.modelValue === '') {
        if (clearWhenMissing) this.value = ''
        return
      }
      const selectedOption = (options || []).find((row) => String(row.value) === String(this.modelValue))
      if (selectedOption) {
        this.value = selectedOption.name
      } else if (clearWhenMissing) {
        this.value = ''
      }
    },
    selectExactMatch() {
      if (!this.value) return false
      const matchedRow = (this.optionSelect || []).find((row) => row.name === this.value)
      if (!matchedRow) return false
      this.select(matchedRow)
      return true
    },
    handleNoBaseLawInChips() {
      if (this.specialValue && this.dataSelectN && this.dataSelectN.length > 0) {
        const noLawIndex = this.dataSelectN.findIndex((item) => item.value === this.specialValue)
        if (noLawIndex !== -1) {
          // Remove from chips
          this.dataSelectN.splice(noLawIndex, 1)
          // Set text input value
          this.value = this.specialLabel || 'ไม่มีกฎหมายแม่บท'
          // Emit update to parent
          this.$emit('update:dataSelect', [...this.dataSelectN])
          this.$emit('update:modelValue', this.specialValue)
          this.$emit('changeSelect', this.specialValue)
        }
      }
    },
    onKeyup(data) {
      this.$emit('keyup-data', data)
      this.dropdown = true
      this.isTyping = !!data
      if (
        this.dataSelect !== undefined &&
        this.specialValue &&
        this.modelValue === this.specialValue &&
        data !== (this.specialLabel || 'ไม่มีกฎหมายแม่บท')
      ) {
        this.$emit('update:modelValue', '')
        this.$emit('changeSelect', '')
      }
      if (!data) {
        this.dropdown = false
        this.isTyping = false
        this.$emit('update:modelValue', '')
        this.$emit('changeSelect', '')
      }
    },
    handleFocusOut(data) {
      this.$emit('focusout', data)
      setTimeout(() => {
        if (!this.dropdown) return
        this.selectExactMatch()
      }, 0)
    },
    handleFocusIn(data) {
      this.$emit('focusin', data)
    },
    handleKeypress(data) {
      this.$emit('keypress', data)
    },
    handleKeydown(data) {
      this.$emit('keydown', data)
    },
    clearSelect() {
      this.value = ''
      this.$emit('update:modelValue', '')
      this.$emit('changeSelect', '')
      this.$emit('keyup-data', '')
      if (this.dataSelect !== undefined) {
        this.dataSelectN = []
        this.$emit('update:dataSelect', [])
      }
      this.dropdown = false
      this.isTyping = false
    },
    toggleDropdown() {
      this.dropdown = !this.dropdown
      if (!this.dropdown) this.isTyping = false
    },
    focusoutBtn(e) {
      if (this.$refs.dropdownAutoComplete) {
        let target = e.target
        if (this.$refs.dropdownAutoComplete !== target && !this.$refs.dropdownAutoComplete.contains(target)) {
          if (this.dropdown) {
            // this.$emit('changeSelect', this.modelValue)
            let check = true
            if (this.selectExactMatch()) {
              check = false
            }
            if (check) {
              this.$emit('update:modelValue', '')
              this.$emit('changeSelect', '')
              this.value = ''
              this.$emit('keyup-data', '')
            }
          }
          this.dropdown = false
          this.isTyping = false
        }
      }
    },
    select(data) {
      if (data.value !== '' && data.value !== undefined) {
        // Add to selected list if not already selected
        if (this.dataSelectN) {
          const alreadySelected = this.dataSelectN.some((item) => item.value === data.value)
          if (!alreadySelected) {
            if (this.specialValue && data.value === this.specialValue) {
              // Selecting "no base law" clears all other chips
              this.dataSelectN.splice(0, this.dataSelectN.length)
              this.$emit('update:dataSelect', [])

              // Set the text value to "ไม่มีกฎหมายแม่บท"
              this.value = data.name
              this.$emit('update:modelValue', this.specialValue)
              this.$emit('changeSelect', this.specialValue)
              this.$emit('keyup-data', '')
              this.dropdown = false
              return
            } else {
              // Selecting a real law removes the "no base law" text if present
              if (
                this.specialValue &&
                (this.value === (this.specialLabel || 'ไม่มีกฎหมายแม่บท') || this.modelValue === this.specialValue)
              ) {
                this.value = ''
                this.$emit('update:modelValue', '')
                this.$emit('changeSelect', '')
              }
              const noLawIndex = this.specialValue
                ? this.dataSelectN.findIndex((item) => item.value === this.specialValue)
                : -1
              if (noLawIndex !== -1) {
                this.dataSelectN.splice(noLawIndex, 1)
              }
            }
            this.dataSelectN.push({ value: data.value, name: data.name })
            this.$emit('update:dataSelect', [...this.dataSelectN])
          }
          // In chip mode: clear the text input and modelValue so
          // the user can immediately search for the next chip.
          this.value = ''
          this.$emit('update:modelValue', '')
          this.$emit('changeSelect', '')
          this.$emit('keyup-data', '')
          this.dropdown = false
          return
        }
        // Single-select mode: clear the input text after selection
        this.value = ''
      }

      this.$emit('update:modelValue', data.value)
      this.$emit('changeSelect', data.value)

      this.dropdown = false
      this.isTyping = false
    },
    removeSelect(index) {
      this.dataSelectN.splice(index, 1)
      this.$emit('update:dataSelect', [...this.dataSelectN])
    },
  },
}
</script>

<style scoped lang="scss">
.component-input-width {
  width: 100%;

  .data-select {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .content-data-select {
      background-color: #eaeaee;
      border-radius: 12.5px;
      padding: 2px 10px;
      margin-right: 10px;
      margin-bottom: 10px;
      font-weight: 400;

      .icon {
        width: 8px;
        height: 8px;
      }
    }
  }

  .component-input {
    position: relative;
    width: 100%;

    .form-control:disabled,
    .form-control[readonly] {
      background-color: #ececec;
      opacity: 0.7;
    }

    .input-size {
      width: 100%;
      border: 1px solid #c1cfe3;
      border-radius: 5px;
      padding: 0 15px;
      font-size: 12px;
      color: #333;
      line-height: 35px;

      &::placeholder {
        font-size: 12px;
      }
    }

    .form-control:focus {
      outline: none;
      box-shadow: 0px 0px;
    }

    .image-select {
      position: absolute;
      top: 20px;
      transform: translateY(-50%);
      right: 16px;
    }

    .pointer {
      width: 10px;
      height: 15px;
    }

    .clear-icon {
      font-size: 14px;
      opacity: 0.5;
      &:hover {
        opacity: 0.8;
      }
    }

    .colorBlack .name-dropdown {
      padding-right: 10px;
      color: #212529;
      opacity: 1;
      font-size: 12px;
      font-weight: 400;
    }
    .dropdown-content {
      display: none;
      position: absolute;
      background-color: #ffffff;
      min-width: 198px;
      box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.16);
      text-align: left;
      z-index: 2;
      color: #0a1629;
      font-size: 12px;
      font-weight: 400;
      border-radius: 10px;
      left: 0;
      right: 0;
      margin-top: 8px;
      overflow: hidden;
      max-height: 420px;

      .add {
        padding: 20px;
        width: 100%;
        cursor: pointer;
        .icon {
          margin-right: 6px;
        }
      }
      .line {
        border-bottom: 1px solid #d8d8d8;
        height: 0px !important;
        opacity: 1 !important;
        margin: 0px !important;
        padding: 0px !important;
      }
    }
  }
}
</style>
